var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 28,
  fill: "none",
  preserveAspectRatio: "none",
  viewBox: "0 4 14 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M1 19.5 4.857 16v4l4.286-4v4L13 16.5"
})));
export { SvgWave as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyOCIgZmlsbD0ibm9uZSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmlld0JveD0iMCA0IDE0IDI4Ij4KICA8cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIgZD0iTTEgMTkuNSA0Ljg1NzE0IDE2djRsNC4yODU3Mi00djRMMTMgMTYuNSIvPgo8L3N2Zz4=";